import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';

import Modal from '../shared/modal';
import TextInput from '../shared/TextInput';
import ColorButton from '../shared/ColorButton';
import SelectBox from '../shared/select/SelectBox';
import DatePicker from '../shared/date-picker/NewDatePicker';

import { LOST_LEADS_PIPELINE_ID } from '../../constants/sales';

const LostLeadModal = (props) => {
  const {
    open,
    onClose,
    onSubmit,
    loading,
    lead,
    stages = [],
    usersList = [],
  } = props;

  const [date, setDate] = useState(moment());
  const [stage, setStage] = useState(null);
  const [notes, setNotes] = useState('');
  const [owner, setOwner] = useState(lead.owner);

  useEffect(() => {
    if (open && lead) {
      setOwner(lead.owner);
    }
  }, [open, lead]);

  useEffect(() => {
    if (!open) {
      setDate(moment());
      setStage(null);
      setNotes('');
      setOwner(null);
    }
  }, [open])

  const stagesOptions = useMemo(() => stages.filter((s) => s.pipelineId === LOST_LEADS_PIPELINE_ID).map((s) => ({
    value: s.id,
    label: s.title,
  })), [stages, lead]);

  const usersOptions = useMemo(() => usersList.map((u) => ({
    value: u.uid,
    label: `${u.firstName} ${u.lastName}`,
  })), [usersList]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Lost Lead'
      className='lead-modal__container'
    >
      <div className='lead-modal__content'>
        <div className='lead-modal__field-container'>
          <div className='secondary m-b-sm font-size-sm'>Lost Date</div>
          <DatePicker
            date={date}
            onDateChange={setDate}
          />
        </div>

        <div className='lead-modal__field-container'>
          <div className='secondary m-b-sm font-size-sm'>Reason Lost</div>
          <SelectBox
            value={stage}
            onChange={setStage}
            options={stagesOptions}
          />
        </div>


        <div className='lead-modal__field-container'>
          <div className='secondary m-b-sm font-size-sm'>Notes</div>
          <TextInput
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder='Add any additional information here'
            multiline
            rows={4}
          />
        </div>

        <div className='lead-modal__field-container'>
          <div className='secondary m-b-sm font-size-sm'>Owner</div>
          <SelectBox
            value={owner}
            onChange={setOwner}
            options={usersOptions}
          />
        </div>

        <div className='d-flex flex-end m-t-lg'>
          <div className='m-r-lg'>
            <ColorButton
              color='grey'
              text='Cancel'
              onClick={onClose}
            />
          </div>
          <ColorButton
            color='blue'
            text='Confirm'
            onClick={() => onSubmit({ date, stage, notes, owner })}
            disabled={loading || !date || !stage}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  )
};

export default LostLeadModal;
